export default "__VITE_ASSET__BEcCSJ8___"